import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import jsonData from "../../../../current-survey-numeric.json";

const engagementGroups = {
  "Role Clarity": ["MQ0044", "MQ0047", "MQ0017"],
  "Resources": ["MQ0048", "MQ0051", "MQ0050"],
  "Work Outcomes": ["MQ0095", "MQ0016", "MQ0059"],
  "Feedback": ["MQ0104", "MQ0173", "MQ0054"],
};

const Heatmap1 = ({ selectedDemographic, filterCriteria }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    // Filter the data based on criteria
    const filteredData = jsonData.filter((item) =>
      Object.keys(filterCriteria).every((key) =>
        filterCriteria[key].length === 0
          ? true
          : filterCriteria[key].includes(item[key])
      )
    );

    // Get unique demographic values, replacing null/undefined with a default label
    const demographicValues = [
      ...new Set(
        filteredData.map((item) => item[selectedDemographic] || "Unknown")
      ),
    ].sort();

    // Prepare series data for each engagement group
    const seriesData = Object.keys(engagementGroups).map((group) => {
      const groupData = demographicValues.map((value) => {
        const responses = filteredData.filter(
          (item) => (item[selectedDemographic] || "Unknown") === value
        );

        // Calculate average score for the group
        const scores = responses.map(
          (response) =>
            engagementGroups[group].reduce(
              (acc, question) => acc + (parseFloat(response[question]) || 0),
              0
            ) / engagementGroups[group].length
        );

        const averageScore = scores.length
          ? scores.reduce((acc, score) => acc + score, 0) / scores.length
          : 0;

        return {
          x: value,
          y: isNaN(averageScore) ? 0 : parseFloat(averageScore.toFixed(2)),
        };
      });

      return { name: group, data: groupData };
    });

    setChartData(seriesData);
  }, [selectedDemographic, filterCriteria]);

  const options = {
    chart: {
      type: "heatmap",
      toolbar: {
        show: false,
        tools: {
          download: true,
        },
      },
    },
    plotOptions: {
      heatmap: {
        shadeIntensity: 0.5,
        colorScale: {
          ranges: [
            { from: 0, to: 2.99, color: "#ffffff", name: "Very Low 0-2.99" },
            { from: 3.0, to: 3.49, color: "#cce6ff", name: "Low 3-3.49" },
            { from: 3.5, to: 3.99, color: "#66b3ff", name: "Medium 3.5-3.99" },
            { from: 4, to: 4.49, color: "#0073e6", name: "High 4-4.49" },
            { from: 4.5, to: 5, color: "#004080", name: "Very High 4.5-5" },
          ],
        },
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#000"],
      },
      formatter: (val) => (isNaN(val) ? "0.0" : val.toFixed(1)),
    },
    xaxis: {
      labels: {
        style: {
          colors: "#6d6d6d",
          fontSize: "0.8rem",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#6d6d6d",
          fontSize: "0.8rem",
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val.toFixed(1)} (Avg)`,
      },
    },
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Chart
        options={options}
        series={chartData}
        type="heatmap"
        height="100%"
      />
    </div>
  );
};

export default Heatmap1;
